<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div class="title">设备详情信息</div>
      <el-table :data="deviceDetails" border stripe class="mt15">
          <el-table-column prop="jigouname" label="归属机构名称"></el-table-column>
          <el-table-column prop="mac" label="MAC地址"></el-table-column>
          <el-table-column prop="cardnumber" label="保修卡号"></el-table-column>
          <el-table-column prop="BomsnName" label="设备类型"></el-table-column>
          <el-table-column prop="SaletypeName" label="销售类型"></el-table-column>
          <el-table-column prop="producename" label="生产商"></el-table-column>
          <el-table-column prop="producetime" label="生产日期"></el-table-column>
          <el-table-column prop="gujianversion" label="固件版本号"></el-table-column>
      </el-table>

      <div class="title mt20">会员信息</div>
      <el-table :data="remberMsg" border stripe class="mt15">
          <el-table-column prop="Loginname" label="用户登录名称"></el-table-column>
          <el-table-column prop="Name" label="用户姓名"></el-table-column>
          <el-table-column prop="Sex" label="用户性别"></el-table-column>
          <el-table-column prop="Phone" label="用户手机号码"></el-table-column>
          <el-table-column prop="Province" label="省"></el-table-column>
          <el-table-column prop="City" label="市"></el-table-column>
          <el-table-column prop="District" label="区"></el-table-column>
          <el-table-column prop="Address" label="常用眼镜地址"></el-table-column>
      </el-table>

      <div class="title mt20">销售机体验机修改记录</div>
      <el-table :data="modificationrecord" border stripe class="mt15">
          <el-table-column prop="BomsnoldName" label="原设备类型"></el-table-column>
          <el-table-column prop="SaletypeoldName" label="原销售类型"></el-table-column>
          <el-table-column prop="BomsnnewName" label="新设备类型"></el-table-column>
          <el-table-column prop="SaletypenewName" label="新销售类型"></el-table-column>
          <el-table-column prop="Adminname" label="操作人员"></el-table-column>
          <el-table-column prop="Createtime" label="操作日期"></el-table-column>
      </el-table>

      <div class="title mt20">设备绑定解绑记录</div>
      <el-table :data="bindUnbindRecord" border stripe class="mt15">
          <el-table-column prop="Loginname" label="用户登录名称"></el-table-column>
          <el-table-column prop="Name" label="用户姓名"></el-table-column>
          <el-table-column prop="Bindstate" label="绑定/解绑"></el-table-column>
          <el-table-column prop="Adminname" label="操作人员"></el-table-column>
          <el-table-column prop="Createtime" label="操作日期"></el-table-column>
      </el-table>

      <div class="title mt20">设备变更记录</div>
      <el-table :data="changeRecord" border stripe class="mt15">
          <el-table-column prop="Jigounameold" label="原归属机构"></el-table-column>
          <el-table-column prop="Jigounamenew" label="变更归属机构"></el-table-column>
          <el-table-column prop="Adminname" label="操作人员"></el-table-column>
          <el-table-column prop="Createtime" label="操作日期"></el-table-column>
      </el-table>

      <el-button type="info" class="mt20" @click="backDeviceManagement">返回</el-button>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      loading: false,
      // 设备详情信息
      deviceDetails: [],
      // 会员信息
      remberMsg: [],
      // 销售机体验机修改记录
      modificationrecord: [],
      // 设备绑定解绑记录
      bindUnbindRecord: [],
      // 设备变更记录
      changeRecord: [],
      parentdata: null
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata

      this.apigetDeviceinfo()

      this.deviceDetails = []
      var deviceDetailsinfo = {}
      deviceDetailsinfo.jigouname = this.parentdata.params.Jigouname
      deviceDetailsinfo.mac = this.parentdata.params.Mac
      deviceDetailsinfo.cardnumber = this.parentdata.params.Cardnumber
      deviceDetailsinfo.BomsnName = this.parentdata.params.BomsnName
      deviceDetailsinfo.SaletypeName = this.parentdata.params.SaletypeName
      deviceDetailsinfo.producename = this.parentdata.params.Producename
      deviceDetailsinfo.producetime = this.parentdata.params.Producetime
      deviceDetailsinfo.gujianversion = this.parentdata.params.Gujianversion
      this.deviceDetails.push(deviceDetailsinfo)
    },
    backDeviceManagement () {
      this.$emit('triggerFunc', '')
    },
    apigetDeviceinfo: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassid: that.parentdata.params.glassid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDeviceinfo, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.remberMsg = response.data.Userlist
            that.modificationrecord = response.data.GlassChangeTypeList
            that.bindUnbindRecord = response.data.Bindlist
            that.changeRecord = response.data.Changejigoulist
            console.log(response.data)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
